import type { InjectionKey } from 'vue'

/** ElementRenderer draws the TEXT/PASSWORD message itself so the input box cannot clip it. */
export const FieldVerifyErrorHostKey: InjectionKey<boolean> = Symbol('fieldVerifyErrorHost')
